import { render, staticRenderFns } from "./App.vue?vue&type=template&id=68b5d29f"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./App.vue?vue&type=custom&index=0&blockType=link&rel=stylesheet&href=styles%2Fdefault.css"
if (typeof block0 === 'function') block0(component)

export default component.exports